import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ScheduleTable_ScheduleFragment } from '../__generated__/ScheduleTable.graphql';

export function TitleCell({
  value,
}: PropsWithChildren<CellProps<ScheduleTable_ScheduleFragment, string>>) {
  return (
    <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontWeight="semibold">
      {value}
    </Box>
  );
}

TitleCell.graphql = {
  fragments: {
    TitleCell_schedule: gql`
      fragment TitleCell_schedule on Schedule {
        id
        title
      }
    `,
  },
};
